/** @jsx jsx */
import { tokens } from '@datacamp/waffles/tokens';
import { jsx } from '@emotion/react';
import { useCallback } from 'react';
import { AnyAction } from 'redux';

import { useDispatch } from '../../interfaces/State';

export type DailyStreakModalProps = {
  nextStep?: AnyAction;
  onExit: () => void;
};

const DailyStreakModal: React.FC<DailyStreakModalProps> = (props) => {
  const { nextStep, onExit } = props;

  const dispatch = useDispatch();

  const onDone = useCallback(() => {
    if (nextStep) {
      dispatch(nextStep);
    }

    onExit();
  }, [dispatch, nextStep, onExit]);

  // TODO: implement
  return (
    <div
      css={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'black',
        color: 'white',
        zIndex: tokens.zIndex.modal,
      }}
    >
      <button type="button" onClick={onDone}>
        Continue
      </button>
    </div>
  );
};

export default DailyStreakModal;
